import {Anchor} from "../core/Anchor";
import {ContainerExtensions} from "../core/ContainerExtensions";
import {IRectangle} from "../core/Geom";
import {Callback} from "../core/Reflection";
import {Sprite} from "../core/Sprite";
import {AnyStoryOptionModel, AnyStorySceneModel} from "../data/StoryModel";
import {GameManager} from "../managers/GameManager";
import {VoiceOverManager} from "../managers/VoiceOverManager";
import {LabelButton} from "./LabelButton";

export class OptionButton extends LabelButton {

    public readonly option: AnyStoryOptionModel;

    constructor(scene: AnyStorySceneModel, option: AnyStoryOptionModel, optionIndex: number, onClick: Callback) {
        super(onClick);
        this.option = option;
        this.label = (option.cc || "").toUpperCase();
        if (this.label && this.label.length > 25) {
            this.labelSize = 18;
            this.labelOffset = this.labelSize * 0.6;
        }
        this.setLayoutTexture("button-option", 0.5, 1);
        const story = GameManager.instance.story;
        const iconTexture = option.icon || (story.optionIcon || "").replace("{option}", option.optionId);
        const icon = this.visuals.addChild(new Sprite(iconTexture, Anchor.bottomCenter));
        if (option.iconPosition) {
            switch (option.iconPosition) {
                case "center":
                    icon.anchor.x = 0.5;
                    icon.anchor.y = 0.5;
                    icon.y = -this.sprite.height * 0.5;
                    break;
                case "top":
                    icon.anchor.x = 0.5;
                    icon.anchor.y = 0;
                    icon.y = -this.sprite.height;
                    break;
                default:
                    icon.x = option.iconPosition.x;
                    icon.y = option.iconPosition.y;
            }
        } else {
            icon.y = -7;
            icon.x = 2;
        }
        this.onLayout();
        this.onOver.add(() => {
            const vo = GameManager.instance.getCurrentSceneOptionVO(optionIndex);
            if (vo) {
                VoiceOverManager.instance.playVO(vo, {priority: -1, skipCC: true});
            }
        });
    }

    public get bodyWidth() {
        return this.sprite.width;
    }

    public getFocusRect(): IRectangle {
        return ContainerExtensions.getGlobalBounds.call(this.sprite);
    }
}
